export default __webpack_public_path__ + "assets/images/f0621952d4c4bc7bd7e4d782e1060d9f.jpg";